import { api } from "./api";

// Fire-and-forget event tracking. Backend validates the event name.
// page_view is de-duplicated to guard against React StrictMode double-effects.
let lastPageView = { path: null, at: 0 };

export function track(name, props = {}) {
  const path = typeof window !== "undefined" ? window.location.pathname : null;
  if (name === "page_view") {
    const now = Date.now();
    if (lastPageView.path === path && now - lastPageView.at < 1500) return;
    lastPageView = { path, at: now };
  }
  try {
    api.post("/api/events", {
      name,
      path,
      ...props,
    }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
